<template>
  <Card
    v-loading="isLoading"
    style="max-width: 200px;
        display: inline-block;
        align: center;
        float: left;
        text-align: center;
        margin-right: 20px; margin-bottom: 20px;">
    <div style="margin-bottom: 15px;">
      <i :class="`${iconName}`" :style="{ color: color, fontSize: '100px' }"/>
    </div>
    <div style="margin-bottom: 20px">
      {{ name }}
    </div>
    <div>
      <el-button
        type="primary"
        @click="onClick"
        :disabled="disabled">
        Prendre le contrôle
      </el-button>
    </div>
  </Card>
</template>
<script>
import Card from '@/components/Card/Card.vue';

export default {
  components: { Card },
  props: {
    name: { type: String },
    color: { type: String },
    iconName: { type: String },
    isLoading: { type: Boolean },
    disabled: { type: Boolean },
  },
  methods: {
    onClick() {
      this.$emit('click', this.name);
    },
  },
};
</script>
